module.exports = __webpack_public_path__ + "static/media/LOGO_ASG.1bf67e9e.png";